import Button from "components/Button";
import { FileSelector } from "components/FileSelector";
import Input from "components/Input";
import { Select } from "components/Select";
import Spinner from "components/Spinner";
import useFileUploader from "hooks/useFileUploader";
import { BsTrash } from "react-icons/bs";
import { COMPANY_TYPES, CURRENCY_TYPES } from "./const";

const CompanyView = ({ index, company, onChange, deleteCompany, disabled }) => {
  const fileUploader = useFileUploader((urls) => {
    onChange({
      businessLicense: [...company.businessLicense, ...urls],
    });
  });

  return (
    <div className="mt-4 -mx-2 border-b pb-4">
      <table>
        <tbody>
          <tr>
            <td className="pb-0">
              <h6>公司 #{index + 1}</h6>
            </td>
            <td>
              {index > 0 && !disabled && (
                <div className="flex justify-end">
                  <Button
                    danger
                    onClick={() => {
                      if (window.confirm("Are you sure? 确认删除?"))
                        deleteCompany();
                    }}
                    className="text-xs"
                  >
                    Delete
                  </Button>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <label>Business Type 业务类型</label>
            </td>
            <td className="w-full">
              <Select
                value={company.businessType}
                disabled={disabled}
                onChange={(e) => onChange({ businessType: e.target.value })}
              >
                <option value="FOREIGN">外贸</option>
                <option value="DOMESTIC">内销</option>
              </Select>
              <span className="pl-2 font-bold text-red-600">*</span>

              <span className="pl-2 font-semibold text-orange-600">
                {company.businessType === "FOREIGN"
                  ? "请使用英文在下面填写该公司信息"
                  : "请使用中文在下面填写该公司信息"}
              </span>
            </td>
          </tr>

          <tr>
            <td>
              <label>Company Name 公司名称</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  disabled={disabled}
                  value={company.name}
                  onChange={(e) => onChange({ name: e.target.value })}
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Register Address 注册地址:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  disabled={disabled}
                  value={company.address}
                  onChange={(e) => onChange({ address: e.target.value })}
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Type 公司类型:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Select
                  disabled={disabled}
                  value={company.type}
                  onChange={(e) => onChange({ type: e.target.value })}
                >
                  {COMPANY_TYPES.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Select>
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Tax Number 税号:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  value={company.taxNumber}
                  disabled={disabled}
                  onChange={(e) => onChange({ taxNumber: e.target.value })}
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Business License 营业执照:</label>
            </td>
            <td className=" space-y-1">
              {company.businessLicense.map((url, lIndex) => (
                <div
                  key={lIndex}
                  className="flex items-center space-x-2 text-xs"
                >
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    {url}
                  </a>
                  <Button
                    disabled={disabled}
                    danger
                    onClick={() => {
                      if (window.confirm("Are you sure? 确认删除?")) {
                        onChange({
                          businessLicense: company.businessLicense.filter(
                            (_, i) => i !== lIndex,
                          ),
                        });
                      }
                    }}
                  >
                    <BsTrash />
                  </Button>
                </div>
              ))}

              {fileUploader.isUploading ? (
                <div className="flex">
                  <div>
                    <Spinner size={18} />
                  </div>
                </div>
              ) : (
                <div className="flex items-center space-x-1">
                  <FileSelector
                    disabled={fileUploader.isUploading || disabled}
                    title="Upload 上传"
                    onChange={(e) => {
                      const files = [...e.target.files];
                      fileUploader.startUpload(files, {
                        companyIndex: index,
                      });
                      e.target.value = null;
                    }}
                  />
                  <span className="pl-1 font-bold text-red-600">*</span>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <label>Accepted Currency 接受货币:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <div>
                  {CURRENCY_TYPES.map((currency) => (
                    <label
                      key={currency}
                      className="inline-flex items-center mr-4 cursor-pointer"
                    >
                      <input
                        disabled={disabled}
                        type="checkbox"
                        checked={
                          company.acceptedCurrencies?.[currency] || false
                        }
                        onChange={(e) => {
                          onChange({
                            acceptedCurrencies: {
                              ...company.acceptedCurrencies,
                              [currency]: e.target.checked,
                            },
                          });
                        }}
                      />
                      <span className="ml-2">{currency}</span>
                    </label>
                  ))}
                </div>
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <label>Payee Name 收款人名称:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  value={company.payeeName}
                  disabled={disabled}
                  onChange={(e) => onChange({ payeeName: e.target.value })}
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Payee Account 收款人帐号:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  value={company.payeeBankAccountNumber}
                  disabled={disabled}
                  onChange={(e) =>
                    onChange({ payeeBankAccountNumber: e.target.value })
                  }
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Payee Bank Branch 收款人银行分行:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  value={company.payeeBankBranchInfo}
                  disabled={disabled}
                  onChange={(e) =>
                    onChange({ payeeBankBranchInfo: e.target.value })
                  }
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>Payee Bank Address 收款人银行地址:</label>
            </td>
            <td>
              <div className="flex justify-between items-center">
                <Input
                  value={company.payeeBankAddress}
                  disabled={disabled}
                  onChange={(e) =>
                    onChange({ payeeBankAddress: e.target.value })
                  }
                />
                <span className="pl-2 font-bold text-red-600">*</span>
              </div>
            </td>
          </tr>
          {company.businessType === "FOREIGN" && (
            <tr>
              <td>
                <label>SWIFT CODE / SWIFT代码:</label>
              </td>
              <td className="w-full">
                <div className="flex justify-between items-center">
                  <Input
                    value={company.swiftCode}
                    disabled={disabled}
                    onChange={(e) => onChange({ swiftCode: e.target.value })}
                  />
                  <span className="pl-2 font-bold text-red-600">*</span>
                </div>
              </td>
            </tr>
          )}
          {company.businessType === "DOMESTIC" && (
            <>
              <tr>
                <td>
                  <label>Invoice Type 发票类型:</label>
                </td>
                <td className="w-full">
                  <Select
                    value={company.invoiceType}
                    disabled={disabled}
                    onChange={(e) => onChange({ invoiceType: e.target.value })}
                  >
                    <option value="NORMAL">普票</option>
                    <option value="PRO">专票</option>
                  </Select>

                  <span className="pl-2 font-bold text-red-600">*</span>
                </td>
              </tr>

              <tr>
                <td>
                  <label>税点:</label>
                </td>
                <td className="w-full">
                  <div className="flex items-center space-x-2">
                    <Input
                      className="w-20"
                      value={company.taxPercent}
                      disabled={disabled}
                      onChange={(e) => onChange({ taxPercent: e.target.value })}
                      placeholder="例如 13%"
                    />
                    <span className="pl-2 font-bold text-red-600">*</span>
                  </div>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyView;
